export default __webpack_public_path__ + "static/media/united-arab-emirates.0f1c301a.svg";